<template>
  <div class="g-container-p">
    <div class="m-container-p">
      <!-- 面包屑 -->
      <div>
        <h3>
          <slot name="title"></slot>
        </h3>
        <slot name="remark"></slot>
        <el-button type="primary"
                   size="small"
                   @click="imgClick">图片</el-button>
        <el-button type="success"
                   size="small"
                   @click="pdfClick">pdf</el-button>
        <div v-if="isImg">
          <image-upload :src="src"
                        :isPic="true"
                        :picImgs="picDataArr"
                        @getDataArrPic="getDataArrPic"
                        style="width: 80%;margin-top: 10px;">
            <i slot="del"
               class="del-p"></i>
          </image-upload>
        </div>
        <div v-if="isPdf">
          <el-upload class="upload-demo"
                     drag
                     action="https://www.iduilv.com/Api/Common/UploadFile"
                     :data="extraData"
                     :before-upload="beforeUpload"
                     :file-list="oldExtraFileList"
                     :limit="1"
                     accept=".pdf"
                     multiple
                     :on-success="handleSuccess"
                     :on-error="handleError"
                     :on-remove="handleRemove"
                     style="width: 80%;">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          </el-upload>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../../../../../html/pages/originality/createTestReport/createTestReport.scss"

import imageUpload from "../../../../../components/imageUpload/qeImageUpload"

export default {
  name: 'updateQeUploadFile',
  props: ['basePicArr', 'baseFileType', 'oldExtraFileList'],
  watch: {
    basePicArr (newValue) {
      this.picDataArr = newValue;
      //   console.log("basePicArr", newValue)
      //   console.log("basePicArr", this.picDataArr)
    },
    baseFileType (newValue) {
      if ("IMG" == newValue) {
        // console.log("baseFileType", newValue)
        this.isImg = true
        this.isPdf = false
      } else {
        this.isImg = false
        this.isPdf = true
      }
    }
  },
  data () {
    return {
      src1: require("../../../../../html/pages/originality/createQe/images/upload.jpg"),
      reportData: {
        id: this.$route.params.id,
        DetName: "",
        DetId: "",
        ImgUrl: [],
        PdfUrl: ""
      },
      picDataArr: this.basePicArr,//原图
      thumPicDataArr: [],//压缩图
      titleText: "",
      type: "",
      JointWarranty: [],//验收单
      extraData: {
        type: 'file',
        file: ''
      },
      isImg: false,
      isPdf: true
    }
  },
  components: {
    imageUpload
  },
  computed: {
    src () {
      return this.src1
    }
  },
  methods: {
    imgClick () {
      //console.log("imgClick", this.picDataArr)
      this.isImg = true
      this.isPdf = false
      this.$emit('getReportDataArr', this.picDataArr, this.extraData, "IMG");
    },
    pdfClick () {
      this.isImg = false
      this.isPdf = true
      this.$emit('getReportDataArr', this.picDataArr, this.extraData, "PDF");
    },
    getDataArrPic (data) {
      this.picDataArr = data
      this.$emit('getReportDataArr', this.picDataArr, this.extraData, "IMG");
    },
    beforeUpload (file) {
      const isPDF = file.type === 'application/pdf';
      const isLt20M = file.size / 1024 / 1024 < 20;

      if (!isPDF) {
        this.$message.error('上传文件只能是PDF格式!');
      }
      if (!isLt20M) {
        this.$message.error('上传文件大小不能超过 20MB!');
      }

      return isPDF && isLt20M;
    },
    handleSuccess (response, file, fileList) {
      // 成功回调
      console.log(response)
      if (response.Type == 'Success') {
        this.$message.success(response.Content)
        this.extraData.file = response.Data
      }
      this.$emit('getReportDataArr', this.picDataArr, this.extraData, "PDF");
      console.log(response.response.Data, file, fileList)
    },
    // 删除文件
    handleRemove (file, fileList) {
      this.extraData.file = '';
      this.$emit('getReportDataArr', this.picDataArr, this.extraData, "PDF");
    },
    handleError (err, file, fileList) {
      // 错误回调
      console.log(err, file, fileList)
    },
    // 上传报告
    async uploadReprot (fn) {

    },
    beforeRouteUpdate (to, from, next) {
      next();
      this.picDataArr = []
      this.thumPicDataArr = []
    },
    reload () {
      this.uploadReprot(item => {
        window.location.reload()
      })
    },
  },
}
</script>

<style scoped>
</style>
